import { createSelector } from 'reselect'

import { getDateTime } from '@/utils/dates'

import type { QueryResponse, RelatedProduction, State } from './types'

export const dateSwitcherSheetSelector = createSelector(
    (state: State) => state.data?.items || [],
    (items: RelatedProduction[]) => {
        return items.map((relatedProduction: RelatedProduction) => {
            return {
                id: relatedProduction.id,
                date: getDateTime(relatedProduction.formattedDate),
                minPrice: !!relatedProduction.localPrices?.minPrice
                    ? relatedProduction.localPrices.minPrice
                    : relatedProduction.minPrice,
                ticketCount: relatedProduction.ticketCount,
                webPath: relatedProduction.webPath,
            }
        })
    },
)

export const i18nRelatedProductionsDataSelector = createSelector(
    (state: State) => state.data,
    (data: QueryResponse | undefined) => {
        if (!data) return
        return data?.i18n
    },
)
